import React from 'react';

import { PrinterFeatures } from './types';
import { FeatureName, FeatureNone, FeatureNumber, FeatureUnit } from './styles';

interface PrinterFeatureProps {
  features?: PrinterFeatures[];
  featureKey: string;
}

const PrinterFeature: React.FC<PrinterFeatureProps> = ({
  features,
  featureKey,
}) => {
  const feature = features.find((f) => f.id === featureKey);

  if (!feature) {
    return (
      <FeatureUnit>
        <FeatureNone data-testid="feature-none" />
      </FeatureUnit>
    );
  }

  return (
    <FeatureUnit>
      {typeof feature.value === 'number' && feature.value > 0 && (
        <FeatureNumber className="body-large">{feature.value}</FeatureNumber>
      )}
      {typeof feature.value === 'string' && (
        <FeatureName className="caption-regular">{feature.value}</FeatureName>
      )}
      <FeatureName className="caption-regular">{feature.name}</FeatureName>
    </FeatureUnit>
  );
};

export default PrinterFeature;
